<template>
  <v-layout wrap xs12>
    <v-flex xs12 text-xs-right>
      <v-btn
        flat
        depressed
        color="secondary"
        class="ma-0"
        @click="filtersVisible = !filtersVisible">
        Filter
        <v-icon class="ml-1">{{ filtersVisible ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</v-icon>
      </v-btn>
    </v-flex>
    <v-slide-y-transition>
      <v-flex xs12 id="timeline_filters" class="pa-0 pt-3" v-if="filtersVisible">
        <Loading :isLoading="filterPreferencesLoading">
          <v-layout wrap mb-2 ml-4>
            <EventFilter
              @toggleFilter="toggleFilter" :icon="filter.icon" :label="filter.label"
              :disabled="filter.disabled" v-for="(filter, idx) in this.availableFilters"
              :key="idx" :color="filter.color">
            </EventFilter>
          </v-layout>
          <v-layout row wrap class="pb-1 mb-0">
            <v-layout wrap style="width:100%; padding-right:45px; position:relative">
              <v-flex xs12 sm6>
                <v-menu
                  ref="dateFromMenu"
                  v-model="dateFromMenu"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  max-width="290px"
                >
                  <v-text-field
                    id="filter_date_from_value"
                    :data-filter-date="dateFromStringified"
                    slot="activator"
                    v-model="dateFromFormatted"
                    label="From"
                    append-icon="event"
                    box
                    :disabled="eventsLoading"
                    class="mr-2"
                  ></v-text-field>
                  <v-date-picker v-model="dateFrom" color="secondary" @input="dateFromMenu = false"></v-date-picker>
                </v-menu>
              </v-flex>

              <v-flex xs12 sm6>
                <v-menu
                  ref="dateToMenu"
                  v-model="dateToMenu"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  max-width="290px"
                >
                  <v-text-field
                    id="filter_date_to_value"
                    :data-filter-date="dateToStringified"
                    slot="activator"
                    v-model="dateToFormatted"
                    label="To"
                    append-icon="event"
                    :disabled="eventsLoading"
                    box
                    class="ml-2"
                  ></v-text-field>
                  <v-date-picker v-model="dateTo" color="secondary" @input="dateToMenu = false"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-tooltip top color="secondary">
                <v-btn
                  slot="activator"
                  class="ma-0"
                  icon
                  flat
                  @click="clearFilters"
                  style="position:absolute; right:0; top:10px;"
                >
                  <v-icon id="filter_dates_clear" color="error">cancel</v-icon>
                </v-btn>
                <span>Clear filters</span>
              </v-tooltip>
            </v-layout>
            <v-flex xs12>
              <v-flex xs12>
                <v-alert
                  :value="!dateFilterValid"
                  type="error"
                  class="mb-3 mt-0"
                >{{ dateFilterFeedback }}</v-alert>
              </v-flex>
            </v-flex>
          </v-layout>
        </Loading>
      </v-flex>
    </v-slide-y-transition>
  </v-layout>
</template>

<script>
import { mapState } from "vuex"
import EventFilter from "@/components/timeline/EventFilter.vue"
import Loading from "@/components/shared/Loading"
import dayjs from "dayjs"
import advancedFormat from "dayjs/plugin/advancedFormat"
dayjs.extend(advancedFormat)

export default {
  name: "EventFilterPanel",
  data: () => {
    return {
      dateFrom: null,
      dateFromFormatted: null,
      dateFromMenu: false,
      dateTo: null,
      dateToFormatted: null,
      dateToMenu: false,
      filterExpandIcon: "filter_list",
      filtersVisible: false,
      dateFilterFeedback: "",
      dateFilterValid: true,
      page: 0,
      perPage: 10,
      isToggled: false,
      isToggled1: false,
      isToggled2: false,
      isToggled3: false,
      isToggled4: false,
      isToggled5: false,
      isToggled6: false,
      isToggled7: false,
      isToggled8: false
    }
  },
  methods: {
    setDateFilterFeedback: function() {
      let dateTo = this.dateTo
      let dateFrom = this.dateFrom

      // Both dates null
      if (dateFrom === null && dateTo === null) {
        this.dateFilterValid = true
        return this.dateFilterValid
      }

      // Continue date filter validation
      if (dateFrom !== null && dateTo !== null) {
        dateTo = Date.parse(dateTo)
        dateFrom = Date.parse(dateFrom)

        if (dateFrom > dateTo) {
          this.dateFilterFeedback = "Date 'from' must be before date 'to'."
          this.dateFilterValid = false
        } else {
          this.dateFilterFeedback = ""
          this.dateFilterValid = true
          // Update filter preferences
        }
      } else {
        this.dateFilterFeedback = ""
        this.dateFilterValid = true
        // Update filter preferences
      }
      return this.dateFilterValid
    },
    clearFilters: function() {
      // Clear date filter
      this.dateTo = null
      this.dateToFormatted = null
      this.dateFrom = null
      this.dateFromFormatted = null
      this.dateFilterValid = true
      // Get filter events with no (null) date values
    },
    formatDate(date) {
      if (!date) return null

      const dateFormat = this.currentUserPreferences.date_format
      return dayjs(date).format(dateFormat)
    },
    toggleFilter({ label }) {
      for (let idx = 0; idx < this.availableFilters.length; idx++) {
        const filter = this.availableFilters[idx]
        if (filter.label === label) {
          filter.disabled = !filter.disabled

          this.page = 0
          this.$store.dispatch("filterIconToggle", {
            id: filter.preference,
            enabled: !filter.disabled,
            page: this.page,
            perPage: this.perPage,
            dateFrom: this.dateFromFormatted,
            dateTo: this.dateToFormatted
          })
        }
      }
    }
  },
  components: {
    Loading,
    EventFilter
  },
  computed: {
    ...mapState({
      eventsLoading: state => state.homepage.timeline.loading,
      timelineFilterIcons: state => state.timeline.timelineFilterIcons,
      getEventTypes: state => state.timeline.event_types,
      currentUserPreferences: state => state.currentUser.me.preferences,
      filterPreferencesLoading: state => state.currentUser.loading
    }),
    availableFilters: function() {
      return [
        { label: "Updated", icon: "cached", disabled: !this.currentUserPreferences.timeline.updates, preference: "updates", color: "green" },
        { label: "Status Change", icon: "flare", disabled: !this.currentUserPreferences.timeline.stateChanges, preference: "stateChanges", color: "error" },
        { label: "Tasks", icon: "done", disabled: !this.currentUserPreferences.timeline.tasks, preference: "tasks", color: "orange" },
        { label: "Documents", icon: "description", disabled: !this.currentUserPreferences.timeline.documents, preference: "documents", color: "purple" },
        { label: "Conversations", icon: "message", disabled: !this.currentUserPreferences.timeline.conversations, preference: "conversations", color: "lightBlue" },
        { label: "Notes", icon: "note", disabled: !this.currentUserPreferences.timeline.notes, preference: "notes", color: "brightBlue" },
        { label: "Created", icon: "note_add", disabled: !this.currentUserPreferences.timeline.created, preference: "created", color: "yellow" },
        { label: "Viewed", icon: "visibility", disabled: !this.currentUserPreferences.timeline.viewed, preference: "viewed", color: "blue" }
      ]
    },
    dateFromStringified: function() {
      // data-* attributes won't show if you pass non-string
      return this.dateFrom === null ? "null" : this.dateFrom.toString()
    },
    dateToStringified: function() {
      // data-* attributes won't show if you pass non-string
      return this.dateTo === null ? "null" : this.dateTo.toString()
    }
  },
  watch: {
    dateTo: {
      handler: function() {
        this.dateToFormatted = this.formatDate(this.dateTo)
        this.setDateFilterFeedback()
        if (this.dateFilterValid) {
          this.$emit("dateFilterChange", { dateFrom: this.dateFromFormatted, dateTo: this.dateToFormatted })
        }
      },
      deep: true
    },
    dateFrom: {
      handler: function() {
        this.dateFromFormatted = this.formatDate(this.dateFrom)
        this.setDateFilterFeedback()
        if (this.dateFilterValid) {
          this.$emit("dateFilterChange", { dateFrom: this.dateFromFormatted, dateTo: this.dateToFormatted })
        }
      },
      deep: true
    }
  }
}
</script>
